export default {
  generic: "Etwas ist schiefgelaufen. Bitte versuchen Sie es erneut.",
  serverError:
    "Ein Serverfehler ist aufgetreten. Bitte versuchen Sie es erneut.",
  network:
    "Netzwerkfehler. Prüfen Sie Ihre Verbindung und versuchen Sie es erneut.",
  validation:
    "Bitte prüfen Sie die eingegebenen Werte und versuchen Sie es erneut.",
  loginFailed: "Anmeldung fehlgeschlagen",
  createActivity: "Fehler beim Erstellen der Aktivität",
  updateActivity: "Fehler beim Aktualisieren der Aktivität",
  activityActivationIncomplete:
    "Diese Aktivität kann noch nicht aktiviert werden. Es fehlt noch: {{items}}.",
  activityActivationMissingDescription: "Beschreibung in jeder Sprache",
  activityActivationMissingPhotos: "mindestens ein Foto",
  activityActivationMissingMenuItems: "Menüpunkte",
  activityActivationMissingPricedItems:
    "mindestens einen Artikel mit Preis größer als null",
  activityActivationMissingAvailability: "mindestens ein Verfügbarkeitsfenster",
  updateServiceCategories: "Fehler beim Aktualisieren der Servicekategorien",
  changeProfileType: "Profiltyp konnte nicht geändert werden",
  saveProfile: "Fehler beim Speichern des Profils",
  loadDevicePresets: "Geräte-Vorlagen konnten nicht geladen werden",
  savePreset: "Vorlage konnte nicht gespeichert werden",
  deletePreset: "Vorlage konnte nicht gelöscht werden",
  createDevice: "Gerät konnte nicht erstellt werden",
  deviceDuplicateSerialNumber:
    "Es existiert bereits ein Gerät mit dieser Seriennummer",
  deviceDuplicateSoftwareId:
    "Der Software-Schlüssel ist bereits dem Gerät mit Seriennummer {{serialNumber}} zugewiesen",
  deviceDuplicateSoftwareIdUnknown:
    "Der Software-Schlüssel ist bereits einem anderen Gerät zugewiesen",
  loadDevices: "Geräte konnten nicht geladen werden",
  loadReaders: "Kartenleser konnten nicht geladen werden",
  loadReaderPresets: "Kartenleser-Vorlagen konnten nicht geladen werden",
  updateDevice: "Gerät konnte nicht aktualisiert werden",
  regenerateCredentials: "Zugangsdaten konnten nicht neu generiert werden",
  assignDevice: "Gerät konnte nicht zugewiesen werden",
  updateHouse: "Struktur konnte nicht aktualisiert werden",
  renameDevice: "Gerät konnte nicht umbenannt werden",
  reorderDevices: "Geräte konnten nicht neu sortiert werden",
  loadHouses: "Strukturen konnten nicht geladen werden",
  loadHosts: "Hosts konnten nicht geladen werden",
  loadSalesAgents: "Vertriebsagenten konnten nicht geladen werden",
  loadOwners: "Verkäufer und Hosts konnten nicht geladen werden",
  loadSellers: "Verkäufer konnten nicht geladen werden",
  loadActivities: "Aktivitäten konnten nicht geladen werden",
  loadRegions: "Regionen konnten nicht geladen werden",
  createHouse: "Struktur konnte nicht erstellt werden",
  createHost: "Gastgeber konnte nicht erstellt werden",
  readerOperation: "Kartenleser-Vorgang fehlgeschlagen",
  addPresence: "Gast konnte nicht registriert werden",
  updatePresence: "Gast konnte nicht aktualisiert werden",
  deletePresence: "Gast konnte nicht entfernt werden",
  createSalesAgent: "Vertriebsagent konnte nicht erstellt werden",
  autoTranslateItem:
    "Automatische Übersetzung fehlgeschlagen. Versuchen Sie es später erneut.",
  forgotPasswordFailed:
    "Zurücksetz-E-Mail konnte nicht gesendet werden. Versuchen Sie es später erneut.",
  setPasswordFailed:
    "Passwort konnte nicht gesetzt werden. Versuchen Sie es erneut oder fordern Sie einen neuen Link an.",
  amendReasonWrongStatus:
    "Diese Buchung kann im aktuellen Status nicht geändert werden.",
  amendReasonRefunded:
    "Diese Buchung wurde erstattet und kann nicht geändert werden.",
  amendReasonRefundRetrying:
    "Eine Erstattung läuft; versuchen Sie es später erneut.",
  amendReasonProviderBlocksAmendment:
    "Diese Buchung ist extern synchronisiert und kann hier nicht geändert werden.",
  amendReasonMissingVisit:
    "Diese Buchung hat kein Besuchsdatum/-zeit zum Ändern.",
  amendRequiresOverride:
    "Kapazitäts- oder Buchungsfrist-Beschränkungen erfordern eine explizite Überschreibung.",
  impersonateUser: "Identitätswechsel für diesen Benutzer nicht möglich.",
} as const;
